import { render } from "./TeacherCard.vue?vue&type=template&id=235436ca&scoped=true"
import script from "./TeacherCard.vue?vue&type=script&lang=js"
export * from "./TeacherCard.vue?vue&type=script&lang=js"

import "./TeacherCard.vue?vue&type=style&index=0&id=235436ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235436ca"]])

export default __exports__